import React, { useContext, useEffect } from 'react'
import Allnewscontent from '../../organisms/Allnewssections/Allnewscontent'
import Footer from '../../organisms/Footersections/Footer'
import { AppContext } from '../../../services/Appcontext'

export default function Allnews() {

  const {allNews, getAllNews} = useContext(AppContext)
  useEffect(() =>{
    getAllNews()
    
  },[])
  // console.log("allNews in all news page",allNews)

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow">
        {allNews.loading? console.log("loading..."):
          <Allnewscontent data={allNews.data} />
        }
      </div>
      <Footer/>
    </div>
  )
}
